export default __webpack_public_path__ + "static/media/edit.4f50be2c.svg";